const References = () => {
  return <div className="references"></div>;
};

export default References;
